import React from 'react';
import Modal from 'react-modal';
import 'moment/locale/ja';

const BookModal = ({ isOpen, message, onConfirm, onClose, disabled, siteId }) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const modalStyle = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1000
    },
    content: {
        position: "absolute",
        left: '50%',
        top: '0',
        transform: 'translate(-50%, 0)',
        padding: "20px",
        width: '80%',
        height: '40%',
        minHeight: '300px',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        overflowX: "hidden",
        pointerEvents: "auto",
        backgroundClip: "padding-box",
        border: "1px rgba(0,0,0,.2)",
        margin: '0'
    }
};


  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyle}>
      <div className="d-flex flex-column align-items-center justify-content-center h-100">
        <div>
          <div className='text-center'><img src={`/${siteId}/icon4.svg`} alt="ロゴ" /></div><br /><div className='text-blue h4'>チケットを使用しますか？
          </div><br />ご使用後はキャンセルができなくなります
        </div>
        <button className='ticketusebtn btn btn-booking w-100 mt-3 p-3 text-white' onClick={handleConfirm} disabled={disabled}>今すぐ使用する</button>
        <button className='btn btn-outline-danger mt-3 p-3 modal-btn w-100' onClick={onClose}>まだ使用しない</button>
      </div>
    </Modal>
  );
};

export default BookModal;